<template>
  <div class="textBlock">
    <img v-if="quote" class="quote" :src="`./img/${quote.content}`" />
    <div class="contentContainerContainer">
      <div class="contentContainer">
        <p v-if="isTitle" class="content title">{{ content }}</p>
        <p v-else class="content">{{ content }}</p>
        <span v-if="footnote" class="footnoteNumber">{{ footnote.number }}</span>
      </div>
    </div>
    <div v-if="footnote" class="footnote">
      <span class="number">{{ footnote.number }}</span>
      <div class="footnoteTextContainer">
        <div class="quoteLine" />
        <p class="footnoteText">{{ footnote.content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Tether from "tether";

export default {
  name: "text-block",
  props: {
    content: {
      type: String,
      required: true
    },
    isTitle: Boolean,
    footnote: Object,
    quote: Object
  },
  mounted: function() {
    if (this.footnote) {
      new Tether({
        element: this.$el.querySelector(".footnote"),
        target: this.$el.querySelector(".content"),
        attachment: "top left",
        targetAttachment: "bottom right",
        offset: "20px 0"
      });
    }
    if (this.quote) {
      new Tether({
        element: this.$el.querySelector(".quote"),
        target: this.$el.querySelector(".content"),
        attachment: "bottom left",
        targetAttachment: "top left",
        offset: "20px 0"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.quote {
  height: 42%;
  width: auto;
}

.contentContainerContainer {
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;

  .contentContainer {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;

    .content {
      white-space: pre;
      height: 5vh;
      font-size: 1.7rem;
      font-family: "MarkaziText_allens";
    }

    .footnoteNumber {
      vertical-align: super;
      line-height: 61px;
      font-size: 1.3rem;
      font-family: "MarkaziText_allens";
      color: #283583;
      padding-right: 0.5rem;
    }

    .title {
      font-family: "Raleway";
      text-transform: uppercase;
      color: #283583;
      font-size: 1.2rem;
      padding-top: 10px;
      font-variant-numeric: lining-nums tabular-nums;
    }
  }
}

.footnote {
  font-family: "MarkaziText_allens";
  font-size: 1.2rem;
  color: #283583;
  display: flex;
  flex-direction: row;

  .number {
    vertical-align: super;
    padding-top: 5px;
    text-align: right;
    font-size: 1.1rem;
  }

  .footnoteTextContainer {
    margin-left: 3px;

    .quoteLine {
      width: 60px;
      height: 1.25px;
      background-color: #283583;
      margin-top: 12px;
    }

    .footnoteText {
      padding-top: -11px;
      margin: 0;
    }
  }
}
</style>
